import React, {Component} from 'react'
import axios from 'axios'

class FlickrImages extends Component {
    constructor(props) {
        super(props)
        this.state = {
            photos: [],
        }
    }

    componentDidMount() {
        this.getImages()
    }

    getImages = () => {
        axios
            .get(
                'https://api.flickr.com/services/rest/?method=flickr.people.getPublicPhotos&api_key=6c673c01aa3ffedc615c86b65e4014f1&user_id=34823328%40N04&per_page=6&page=1&format=json&nojsoncallback=1'
            )
            .then(result => {
                this.setState({photos: result.data.photos.photo})
            })
            .catch(error => {
                console.log(`Error occured while fetching data from Flickr: ${error.message}`)
            })
    }

    render() {
        return (
            <div className="flickr-images">
                {this.state.photos.map(photo => (
                    <div key={photo.id} className="flickr-photo">
                        <a
                            href={`https://www.flickr.com/photos/${photo.owner}/${photo.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={`https://farm${photo.farm}.staticflickr.com/${photo.server}/${
                                    photo.id
                                }_${photo.secret}_s.jpg`}
                                alt={photo.title}
                            />
                        </a>
                    </div>
                ))}
            </div>
        )
    }
}

export default FlickrImages



// WEBPACK FOOTER //
// ./src/components/FlickrImages.js